var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    viewBox: "184 -833.23 592 697.23",
    width: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M591.61-240q-33.3 0-57.07-23.54-23.77-23.55-23.77-56.85t23.54-57.07q23.55-23.77 56.85-23.77t57.07 23.54Q672-354.14 672-320.84t-23.54 57.07Q624.91-240 591.61-240M240.62-136q-24.32 0-40.47-16.5T184-192.62v-478.76q0-23.62 16.15-40.12t40.47-16.5h102.76v-105.23h35.08V-728h206.16v-105.23h32V-728h102.76q24.32 0 40.47 16.5T776-671.38v478.76q0 23.62-16.15 40.12T719.38-136zm0-32h478.76q9.24 0 16.93-7.69t7.69-16.93v-310.76H216v310.76q0 9.24 7.69 16.93t16.93 7.69M216-535.39h528v-135.99q0-9.24-7.69-16.93T719.38-696H240.62q-9.24 0-16.93 7.69T216-671.38zm0 0V-696z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvent);
export default __webpack_public_path__ + "static/media/event.dff938dbc27dbf1822314c0a4757a13c.svg";
export { ForwardRef as ReactComponent };